import { render, staticRenderFns } from "./pending-list.vue?vue&type=template&id=31eb01c9&"
import script from "./pending-list.vue?vue&type=script&lang=js&"
export * from "./pending-list.vue?vue&type=script&lang=js&"
import style0 from "./pending-list.vue?vue&type=style&index=0&id=31eb01c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports